module.exports = [
  "$scope",
  "$uibModalInstance",
  "$timeout",
  "Authentication",
  "item",
  "pages", "formValidate", "canValidateTeamLeader","canValidateTeamLeaderPrev",
  "$rootScope",
  "$serverData", "Form", 'toast', '$translate', '$http', 'myTenant','$uibModal', 'Department',
  function (
    $scope, $uibModalInstance, $timeout,
    Authentication,
    item, pages, formValidate, canValidateTeamLeader,canValidateTeamLeaderPrev,
    $rootScope,
    $serverData, Form, toast, $translate, $http, myTenant,$uibModal, Department
  ) {
    var _this = this;
    _this.user = Authentication.currentUserInfo();
    // console.log('_this.user', _this.user)
    _this.users_ids = [_this.user.id].concat((_this.user.tags || []).flatMap(t => t.id));

    this.isAdmin = Authentication.isAuthorized("admin");
    this.isSupervisor = Authentication.isAuthorized("supervisor");
    this.isOwner = Authentication.isAuthorized("owner");
    
    _this.message = "";
    _this.pages = pages;
    _this.formValidate = formValidate;

    _this.item = item;
    _this.formValidate = formValidate;
    _this.canValidateTeamLeader = canValidateTeamLeader; // las instancias y si es team leader se evalua en validateDirective.js
    _this.canValidateTeamLeaderPrev = canValidateTeamLeaderPrev; //Habilitado el teamLeader en la instancia anterior
    _this.onlyCancel = _this.formValidate.onlyCancel;
    // Etapa fijada al abrir el modal. No recalcular con item.validate.length al guardar (evita race entre pestañas).
    _this.lockedValidationStage = (typeof _this.formValidate.validationStage === 'number')
      ? _this.formValidate.validationStage
      : (_this.item.validate || []).length;

    this.comments = {
        select: '',
        comments: '',
    }

    // Archivos adjuntos para Cancelar/Rechazar (como docsValidate en validaciones)
    this.commentsFilesList = []; // { fileName, fileUrl, filename }
    this.commentsFilesModel = []; // { uri, name } para enviar a API
    this.isUploadingFiles = false;
    this.tenantId = undefined;
    myTenant.load().then(function () {
      _this.tenantId = myTenant.get().id;
    });

    // console.log('$serverData.server', $serverData.server)
    // _this.urlReport = window.location.protocol.concat("//", window.location.host, "/api").concat()
    _this.urlReport = $serverData.server.concat(
      "/departments/",
      item.deptId,
      "/forms/",
      item.formId,
      "/html/",
      item.id
    );
    // console.log('_this.urlReport', _this.urlReport)

    _this.generatingPdf = false;
    $rootScope.$on("generating-pdf", function (event, data) {
        _this.generatingPdf = !!(data && data.generatingPdf);
    });

    _this.getPDF = function () {
        if (_this.generatingPdf) {
            return;
        }
        $rootScope.$broadcast("generating-pdf", { generatingPdf: true });
        return Department.pdf({
            departmentId: _this.item.deptId,
            formId: _this.item.formId,
            itemId: _this.item.id
        })
        .$promise.then(function (response) {
            var pdfUrl = response.response;
            window.open($serverData.server + pdfUrl, "_blank");
            $rootScope.$broadcast("generating-pdf", { generatingPdf: false });
        })
        .catch(function () {
            $rootScope.$broadcast("generating-pdf", { generatingPdf: false });
        });
    };

    this.validate = {};
    this.validate.payload = {};
    _this.item.validate = _this.item.validate || [];
    _this.showCancel = _this.item.validate.length > 0 && _this.formValidate.allowCancel;
    _this.showCancelOptions = false;
    _this.showRejectOptions = false;
    this.cancelOptions = _this.formValidate.allowCancelOptionList;
    this.rejectOptions = _this.formValidate.allowRejectOptionList;

    _this.showValidate = _this.item.validate.length < _this.formValidate.instances;
    const instanceNumber = _this.item.validate.length;
    if (!Authentication.isAuthorized(["admin"])) {
      if (_this.showCancel && _this.formValidate.type == "instance-defined" && _this.formValidate.validate_defined) {
        _this.showCancel = formValidate.validate_defined[instanceNumber - 1].validate_users.length == 0
          || formValidate.validate_defined[instanceNumber - 1].validate_users.some(user => _this.users_ids.includes(user.id))
          || formValidate.validate_defined[instanceNumber].validate_users.some(user => _this.users_ids.includes(user.id))
          || _this.item.validate_tagsFromMask?.some(t => _this.users_ids.includes(t.id))
          || _this.canValidateTeamLeader || _this.canValidateTeamLeaderPrev;
      }
      if (_this.showValidate && _this.formValidate.type == "instance-defined" && _this.formValidate.validate_defined) {
        _this.showValidate = (!(_this.canValidateTeamLeader ||  _this.canValidateTeamLeaderPrev) && formValidate.validate_defined[instanceNumber].validate_users.length == 0)
          || formValidate.validate_defined[instanceNumber].validate_users.some(user => _this.users_ids.includes(user.id))
          || _this.item.validate_tagsFromMask?.some(t => _this.users_ids.includes(t.id))
          || _this.canValidateTeamLeader;
      }
    }

    _this.totalInstances = _this.formValidate.instances;
    _this.isApproved = (_this.item.validate.length == _this.totalInstances && this.item.validate[_this.totalInstances - 1]?.state == 'OK') ? true : false; // Last validate is APPROVED
    _this.isRejected = ( this.item.validate[_this.item.validate.length - 1]?.state == 'REJECT') ? true : false; // Last validate is REJECTED

    _this.validate.user = {
      firstName: _this.user.firstName,
      lastName: _this.user.lastName,
      email: _this.user.email,
      _id: _this.user.id,
    };

    // CANCEL LAST VALIDATE
    _this.cancelLastValidate = () => {
        if (_this.cancelOptions?.length > 0) {
            _this.validate.comments = '';
        } else {
            // toast.error($translate.instant('Debes escribir algún comentario con el motivo de cancelación'));
        }
        _this.showCancelOptions = true;
    }


      _this.openHistory = function (item) {
          const canSeeAdditionalHistoryFields = _this.isAdmin || _this.isOwner || _this.isSupervisor;
          $uibModal.open({
              animation: true,
              templateUrl: 'directives/validateHistoryGraphModal.html',
              controller: require("./validateDirectiveHistoryModal"),
              controllerAs: "modal",
              size: "xlg",
              windowClass: "dialog",
              bindToController: true,
              resolve: {
                  item: () => _this.item,
                  pages: () => typeof (_this.pages) == "string" ? JSON.parse(_this.pages) : (_this.pages || []),
                  formDefinition: ["Form", function (Form) {
                      const formId = _this.item?.formId;
                      if (!formId) return null;
                      return Form.find({
                          filter: {
                              where: { id: formId },
                              fields: ["id", "name", "validate_pages", "pages"],
                          },
                      }).$promise
                          .then(function (forms) { return (forms && forms[0]) || null; })
                          .catch(function () { return null; });
                  }],
                  canSeeAdditionalHistoryFields: () => canSeeAdditionalHistoryFields,
              }
          }).result.then((result) => {
          }, function () { //dismiss
          });
      };

    _this.cancelCanceleLastValidate = () => {
        _this.validate.comments = '';
        _this.commentsFilesList = [];
        _this.commentsFilesModel = [];
        _this.showCancelOptions = false;
    }

    _this.selectFile = function () {
      let input = document.createElement('input');
      input.type = 'file';
      input.multiple = true;
      input.style.display = 'none';
      document.body.appendChild(input);
      input.addEventListener('change', function () {
        let files = Array.from(input.files);
        if (files.length > 0) {
          files.forEach(function (file) {
            _this.uploadCommentFile(file);
          });
        }
        document.body.removeChild(input);
      });
      input.click();
    };

    _this.uploadCommentFile = function (file) {
      if (!file || !_this.tenantId) {
        if (!_this.tenantId) {
          toast.error($translate.instant('Error: No se pudo obtener el tenantId.'));
        }
        return;
      }
      _this.isUploadingFiles = true;
      let timestamp = new Date().getTime();
      let fd = new FormData();
      let hostApi = $serverData.server;
      let ext = file.name.slice(file.name.lastIndexOf('.') + 1);
      let uniqueName = 'validate-docs-' + _this.item.id + '-' + timestamp + '.' + ext;
      fd.append('file', file, uniqueName);
      $http.post(hostApi.concat('/containers/', _this.tenantId, '/upload/'), fd, {
        headers: { 'Content-Type': undefined },
        transformRequest: angular.identity
      }).then(function (res) {
        let fileResult = res.data.result.files.file[0];
        let filename = fileResult.name;
        let fileUrl = hostApi + '/containers/' + _this.tenantId + '/download/' + filename;
        let fileObj = {
          fileName: file.name,
          fileUrl: fileUrl,
          filename: filename
        };
        _this.commentsFilesList.push(fileObj);
        _this.commentsFilesModel.push({ uri: fileUrl, name: file.name });
        _this.isUploadingFiles = false;
        toast.success($translate.instant('Archivo subido correctamente.'));
      }, function (err) {
        console.error('Error al subir archivo', err);
        toast.error($translate.instant('Error al subir el archivo.'));
        _this.isUploadingFiles = false;
      });
    };

    _this.removeCommentFile = function (index) {
      if (index === undefined || index < 0 || index >= _this.commentsFilesList.length) return;
      _this.commentsFilesList.splice(index, 1);
      _this.commentsFilesModel.splice(index, 1);
      toast.success($translate.instant('Archivo eliminado.'));
    };

    _this.downloadCommentFile = function (fileObj) {
        if (!fileObj || !fileObj.fileUrl) return;
        let docToken = Authentication.currentDocToken();
        let downloadUrl = fileObj.fileUrl + (docToken ? '?access_token=' + docToken : '');
        $http({ method: 'GET', url: downloadUrl, responseType: 'blob' }).then(function (response) {
            let blob = new Blob([response.data], { type: response.headers('Content-Type') || 'application/octet-stream' });
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileObj.fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
        }, function (error) {
            console.error('Error descargando el archivo:', error);
            toast.error($translate.instant('No se pudo descargar el archivo: ') + fileObj.fileName);
        });
    };

    _this.acceptCancelLastValidate = () => {
        const trimmedComments = (_this.comments.comments || '').trim();

        if (!trimmedComments) {
            if (_this.showCancelOptions) {
                toast.error($translate.instant('Debe seleccionar un motivo de cancelación'));
                return;    
            } else {
                toast.error($translate.instant('Debes escribir algún comentario con el motivo de cancelación'));
                return;
            }
        }

        _this.validate.comments = _this.comments.select
            ? `${_this.comments.select}.\n${trimmedComments}`
            : trimmedComments;

        let cancelBody = { comments: _this.validate.comments };
        if (_this.commentsFilesModel && _this.commentsFilesModel.length > 0) {
            cancelBody.docs = _this.commentsFilesModel;
        }
        Form.CancelLastValidation({ itemId: _this.item.id }, cancelBody)
            .$promise.then(function (status) {
                _this.item.validate.pop();
                $rootScope.$broadcast("onValidateItem", _this.item, $uibModalInstance);
                $uibModalInstance.close({ action: 'cancel', status: angular.copy(status), item: angular.copy(_this.item) });;
            })
            .catch(function (err) {
                console.log(err);
                _this.message = err.data.error?.message || "Error al intentar grabar validación";
                toast.error($translate.instant(_this.message));
                $uibModalInstance.close({ action: 'cancel', status: 'error' });
            });
    }

    // REJECT VALIDATION
    _this.rejectValidation = () => {
        if (_this.rejectOptions?.length > 0) {
            _this.validate.comments = '';
        } else {
            toast.error($translate.instant('Debes escribir algún comentario con el motivo de rechazo'));
        }
        _this.showRejectOptions = true;
    }

    _this.cancelRejecteValidate = () => {
        _this.validate.comments = '';
        _this.commentsFilesList = [];
        _this.commentsFilesModel = [];
        _this.showRejectOptions = false;
    }

    _this.acceptRejectValidate = () => {

        const trimmedComments = (_this.comments.comments || '').trim();

        if (!trimmedComments) {
            if (_this.showRejectOptions) {
                toast.error($translate.instant('Debe seleccionar un motivo de rechazo'));
                return;    
            } else {
                toast.error($translate.instant('Debes escribir algún comentario con el motivo de rechazo'));
                return;
            }
        }

        _this.validate.comments = _this.comments.select
            ? `${_this.comments.select}.\n${trimmedComments}`
            : trimmedComments;

        if (_this.commentsFilesModel && _this.commentsFilesModel.length > 0) {
            _this.validate.docs = _this.commentsFilesModel;
        }
        _this.save('REJECT');
    }

    // SAVE: ACCEPT - REJECT
    _this.save = function (state) {
        // console.log('_this.validate', _this.validate)
        // console.log('_this.validate.comments', _this.validate.comments)
        if (_this.loading) return;
        _this.loading = true;
        _this.validate.state = state;

        Form.validateItem({ itemId: _this.item.id, validationStage: _this.lockedValidationStage }, _this.validate)
            .$promise.then(function (status) {
                _this.validate = { ..._this.validate, updatedAt: new Date()};
                _this.item.validate.push(_this.validate);
                $rootScope.$broadcast("onValidateItem", _this.item, $uibModalInstance);

                // console.log('Cerrando modal con:', { action: 'save', state: state, status: status, item: _this.item });
                $uibModalInstance.close({ action: 'save', state: state, status: angular.copy(status), item: angular.copy(_this.item) });;
            })
            .catch(function (err) {
                console.log(err);
                _this.message = err.data.error?.message || "Error al intentar grabar validación";
                toast.error($translate.instant(_this.message));
                $uibModalInstance.close({ action: 'save', state: state, status: 'error' });
            });
    };

    // Validación explícita del payload contra la definición de campos. No depende de supervisorFieldsForm porque los campos dinámicos
    // (text/number/select sin "name", simplelist y formula) NO se registran como controles del form, por lo que $invalid siempre da false.
    _this.valueIsEmpty = function (value) {
        return value === undefined || value === null || value === '' ||
            (Array.isArray(value) && value.length === 0);
    };

    // Valida un nodo de un registro de simplelist (puede ser un group con nodes).
    _this.recordNodeValid = function (node, record) {
        if (node.type === 'group' && node.nodes && node.nodes.length > 0) {
            if (node.inactiveGroup === true) return true;
            return node.nodes.every(function (subnode) {
                return _this.recordNodeValid(subnode, record);
            });
        }
        var cell = record ? record[node.id] : undefined;
        if (cell && cell.valid === false) {
            return false;
        }
        if (node.validation && node.validation.required) {
            return cell && !_this.valueIsEmpty(cell.value);
        }
        return true;
    };

    _this.validateFieldsList = function (fields, payload) {
        return (fields || []).every(function (field) {
            var entry = payload ? payload[field.id] : undefined;
            var value = entry ? entry.value : undefined;

            // date/time/timestamp marcan valid=false cuando el valor está fuera del rango configurado.
            if (entry && entry.valid === false) {
                return false;
            }

            if (field.type === 'group') {
                // Un grupo inactivo (por requires/dynamicRequires) no debe exigir sus campos: sus valores se limpian al ocultarse.
                if (field.inactiveGroup === true) {
                    return true;
                }
                return _this.validateFieldsList(field.nodes || [], payload);
            }

            if (field.type === 'simplelist') {
                if (field.validation && field.validation.required && _this.valueIsEmpty(value)) {
                    return false;
                }
                if (Array.isArray(value)) {
                    return value.every(function (record) {
                        return (field.nodes || []).every(function (node) {
                            return _this.recordNodeValid(node, record);
                        });
                    });
                }
                return true;
            }

            if (field.validation && field.validation.required) {
                return !_this.valueIsEmpty(value);
            }
            return true;
        });
    };

    _this.isPayloadValid = function () {
        var fields = (_this.pages && _this.pages[0] && _this.pages[0].fields) || [];
        return _this.validateFieldsList(fields, _this.validate.payload);
    };

    // // DEBUG: inspeccionar el estado del formulario de validación.
    // // Permite ver por qué "Aprobar" queda habilitado/deshabilitado y qué
    // // controles registró el form (el simple list NO registra controles aquí).
    // _this.debugValidationForm = function (origin) {
    //     var form = $scope.supervisorFieldsForm;
    //     if (!form) {
    //         console.warn('[validate][' + (origin || 'manual') + '] supervisorFieldsForm aún no está disponible en el scope');
    //         return;
    //     }

    //     var controls = (form.$$controls || []).map(function (c) {
    //         return {
    //             name: c.$name || '(sin name)',
    //             invalid: c.$invalid,
    //             errors: Object.keys(c.$error || {}).join(', ') || '-',
    //             value: c.$modelValue,
    //         };
    //     });

    //     console.group('[validate][' + (origin || 'manual') + '] supervisorFieldsForm');
    //     console.log('$invalid:', form.$invalid, '| $valid:', form.$valid, '| $dirty:', form.$dirty);
    //     console.log('$error:', form.$error);
    //     console.log('Controles registrados en el form (' + controls.length + '):');
    //     if (controls.length && console.table) {
    //         console.table(controls);
    //     } else {
    //         console.log(controls);
    //     }
    //     // Campos definidos en la página (incluye los simplelist que NO se validan a nivel form)
    //     try {
    //         var fields = (_this.pages && _this.pages[0] && _this.pages[0].fields) || [];
    //         var simpleLists = fields.filter(function (f) { return f.type === 'simplelist'; });
    //         console.log('Campos de la página:', angular.copy(fields));
    //         console.log('Simple lists detectados (' + simpleLists.length + '):', angular.copy(simpleLists));
    //         simpleLists.forEach(function (sl) {
    //             var entry = _this.validate.payload[sl.id];
    //             console.log('  > simplelist "' + (sl.name || sl.id) + '" => registros:', entry ? angular.copy(entry.value) : '(sin datos en payload)',
    //                 '| requerido:', !!(sl.validation && sl.validation.required));
    //         });
    //     } catch (e) {
    //         console.warn('[validate] No se pudieron inspeccionar los campos de la página', e);
    //     }
    //     console.log('isPayloadValid():', _this.isPayloadValid());
    //     console.log('payload (modal.validate.payload):', angular.copy(_this.validate.payload));
    //     console.groupEnd();
    // };

    // // Verificar cada vez que cambie la validez del formulario.
    // $scope.$watch('supervisorFieldsForm.$invalid', function (newVal, oldVal) {
    //     console.log('[validate] supervisorFieldsForm.$invalid:', oldVal, '=>', newVal);
    //     _this.debugValidationForm('watch');
    // });

    $timeout(function () {
        const container = document.querySelector('.cont-il');
        const dividerHeight = 6;

        $scope.topHeight = container.offsetHeight / 2;
        $scope.bottomHeight = container.offsetHeight / 2 - dividerHeight;

        let isResizing = false;

        // Orientation View Settings
        $scope.isHorizontal = JSON.parse(localStorage.getItem("validationFlip") || false); // false por defecto, inicia en vista vertical.

        $scope.toggleOrientation = function () {
            $scope.isHorizontal = !$scope.isHorizontal;

            if ($scope.isHorizontal) {
                localStorage.setItem("validationFlip", true);
            } else {
                delete localStorage.validationFlip;
            }
        };

        $scope.startResizing = function (event) {
            // event.preventDefault();
            isResizing = true;
            $scope.isResizing = true;
            document.body.style.cursor = 'row-resize';

            const containerRect = container.getBoundingClientRect();

            const onMouseMove = function (e) {
                if (!isResizing) return;

                const offsetY = e.clientY - containerRect.top;

                const proposedTopHeight = offsetY;
                const proposedBottomHeight = containerRect.height - offsetY - dividerHeight;

                if (proposedTopHeight >= 30 && proposedBottomHeight >= 30) {
                    $scope.$apply(() => {
                        $scope.topHeight = proposedTopHeight;
                        $scope.bottomHeight = proposedBottomHeight;
                    });
                }
            };

            const onMouseUp = function () {
                isResizing = false;
                $scope.isResizing = false;
                document.body.style.cursor = 'default';
                document.removeEventListener('mousemove', onMouseMove);
                document.removeEventListener('mouseup', onMouseUp);
            };

            document.addEventListener('mousemove', onMouseMove);
            document.addEventListener('mouseup', onMouseUp);
        }
    }, 0);

    if (_this.onlyCancel) {
        _this.cancelLastValidate();
    }
   
  },
];

